import type { Tone } from '@/design-system';
import type { Website } from './api';

type Status = Website['status'];

/** Status → pill tone (`SS` in the design logic). */
export const STATUS_TONE: Record<Status, Tone> = {
  draft: 'mute',
  research_ready: 'mute',
  designing: 'acc',
  preview_ready: 'acc',
  demo_published: 'warn',
  pending_production: 'warn',
  production: 'ok',
  archived: 'mute',
};

/** The 7-step lifecycle (`LIFE`); `archived` sits outside it. */
export const LIFECYCLE = ['draft', 'research_ready', 'designing', 'preview_ready', 'demo_published', 'pending_production', 'production'] as const;

/** «Opening the site that is in design lands on AI Designer; any other site lands on Обзор» (DESIGN_SPEC §4.5). */
export function landingTab(site: Website): 'designer' | 'overview' {
  return site.status === 'designing' ? 'designer' : 'overview';
}
